import { render, staticRenderFns } from "./FormHeader.vue?vue&type=template&id=a4aafbc2&scoped=true"
import script from "./FormHeader.vue?vue&type=script&lang=js"
export * from "./FormHeader.vue?vue&type=script&lang=js"
import style0 from "./FormHeader.vue?vue&type=style&index=0&id=a4aafbc2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4aafbc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4aafbc2')) {
      api.createRecord('a4aafbc2', component.options)
    } else {
      api.reload('a4aafbc2', component.options)
    }
    module.hot.accept("./FormHeader.vue?vue&type=template&id=a4aafbc2&scoped=true", function () {
      api.rerender('a4aafbc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/compliance/AttestationManager/Forms/FormHeader.vue"
export default component.exports